/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raw_Bronze_Falcon_FlipInputs */

const en_raw_bronze_falcon_flip = /** @type {(inputs: Raw_Bronze_Falcon_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluded`)
};

const de_raw_bronze_falcon_flip = /** @type {(inputs: Raw_Bronze_Falcon_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgeschlossen`)
};

/**
* | output |
* | --- |
* | "Excluded" |
*
* @param {Raw_Bronze_Falcon_FlipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const raw_bronze_falcon_flip = /** @type {((inputs?: Raw_Bronze_Falcon_FlipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raw_Bronze_Falcon_FlipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_raw_bronze_falcon_flip(inputs)
	return de_raw_bronze_falcon_flip(inputs)
});